import React from "react";
import { IReportingPeriodPermissionPresenter } from "../../../../../presenter/reporting/ReportingPeriodPermissionPresenter";
import DataGrid from "../../../../components/app/grid/DataGrid";
import { Form } from "antd";
import CreateReportingPeriodPermissionForm, {
  CreateReportingPeriodPermissionFormProps
} from "./CreateReportingPeriodPermissionForm";
import UpdateReportingPeriodPermissionForm, {
  UpdateReportingPeriodPermissionFormProps
} from "./UpdateReportingPeriodPermissionForm";

export interface Props {
  title: string | React.ReactElement;
}
export interface State extends IReportingPeriodPermissionPresenter {}

export default class ReportingPeriodPermissionsGrid extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate, reportingPeriodPermissions = [], users } = this.state;

    const CreateForm = Form.create<CreateReportingPeriodPermissionFormProps>(
      {}
    )(CreateReportingPeriodPermissionForm);

    const UpdateForm = Form.create<UpdateReportingPeriodPermissionFormProps>(
      {}
    )(UpdateReportingPeriodPermissionForm);

    const columns = [
      {
        title: translate("reporting_period_permission_page.user"),
        dataIndex: "user",
        key: "user"
      },
      {
        title: translate("reporting_period_permission_page.action"),
        dataIndex: "action",
        key: "action"
      },
      {
        title: translate("reporting_period_permission_page.from_date"),
        dataIndex: "fromDate",
        key: "fromDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.fromDate, b.fromDate)
      },
      {
        title: translate("reporting_period_permission_page.to_date"),
        dataIndex: "toDate",
        key: "toDate",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.toDate, b.toDate)
      }
    ];

    return (
      <DataGrid
        title={this.props.title}
        translate={translate}
        columns={columns}
        dataSource={reportingPeriodPermissions}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        onCreate={this.state.createReportingPeriodPermission}
        createModalTitle={translate(
          "reporting_period_permission_page.insert_modal_title"
        )}
        updateForm={UpdateForm}
        updateModalTitle={translate(
          "reporting_period_permission_page.update_modal_title"
        )}
        onUpdate={this.state.updateReportingPeriodPermission}
        addButtonText={translate(
          "reporting_period_permission_page.add_button_text"
        )}
        codebooks={users}
        loading={this.state.loaders.reportingPeriodPermissionsLoaders}
      />
    );
  }
}
